webpackJsonp([1],{

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.needCLodop = needCLodop;
exports.getLodop = getLodop;
var CreatedOKLodop7766 = null;

function needCLodop() {
  try {
    var ua = navigator.userAgent;
    if (ua.match(/Windows\sPhone/i) != null) return true;
    if (ua.match(/iPhone|iPod/i) != null) return true;
    if (ua.match(/Android/i) != null) return true;
    if (ua.match(/Edge\D?\d+/i) != null) return true;

    var verTrident = ua.match(/Trident\D?\d+/i);
    var verIE = ua.match(/MSIE\D?\d+/i);
    var verOPR = ua.match(/OPR\D?\d+/i);
    var verFF = ua.match(/Firefox\D?\d+/i);
    var x64 = ua.match(/x64/i);
    if (verTrident == null && verIE == null && x64 !== null) return true;else if (verFF !== null) {
      verFF = verFF[0].match(/\d+/);
      if (verFF[0] >= 42 || x64 !== null) return true;
    } else if (verOPR !== null) {
      verOPR = verOPR[0].match(/\d+/);
      if (verOPR[0] >= 32) return true;
    } else if (verTrident == null && verIE == null) {
      var verChrome = ua.match(/Chrome\D?\d+/i);
      if (verChrome !== null) {
        verChrome = verChrome[0].match(/\d+/);
        if (verChrome[0] >= 42) return true;
      };
    };
    return false;
  } catch (err) {
    return true;
  };
};

if (needCLodop()) {
  var head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;
  var oscript = document.createElement("script");
  oscript.src = "http://localhost:8000/CLodopfuncs.js?priority=1";
  head.insertBefore(oscript, head.firstChild);

  oscript = document.createElement("script");
  oscript.src = "http://localhost:18000/CLodopfuncs.js?priority=0";
  head.insertBefore(oscript, head.firstChild);
};

function getLodop(oOBJECT, oEMBED) {
  var strHtmInstall = "<br><font color='#FF00FF'>打印控件未安装!点击这里<a href='install_lodop32.exe' target='_self'>执行安装</a>,安装后请刷新页面或重新进入。</font>";
  var strHtmUpdate = "<br><font color='#FF00FF'>打印控件需要升级!点击这里<a href='install_lodop32.exe' target='_self'>执行升级</a>,升级后请重新进入。</font>";
  var strHtm64_Install = "<br><font color='#FF00FF'>打印控件未安装!点击这里<a href='install_lodop64.exe' target='_self'>执行安装</a>,安装后请刷新页面或重新进入。</font>";
  var strHtm64_Update = "<br><font color='#FF00FF'>打印控件需要升级!点击这里<a href='install_lodop64.exe' target='_self'>执行升级</a>,升级后请重新进入。</font>";
  var strHtmFireFox = "<br><br><font color='#FF00FF'>（注意：如曾安装过Lodop旧版附件npActiveXPLugin,请在【工具】->【附加组件】->【扩展】中先卸它）</font>";
  var strHtmChrome = "<br><br><font color='#FF00FF'>(如果此前正常，仅因浏览器升级或重安装而出问题，需重新执行以上安装）</font>";
  var strCLodopInstall = "<br><font color='#FF00FF'>CLodop云打印服务(localhost本地)未安装启动!点击这里<a href='http://www.c-lodop.com/download/CLodop_Setup_for_Win32NT_https_3.008Extend.zip' target='_self'>执行安装</a>,安装后请刷新页面。</font>";
  var strCLodopUpdate = "<br><font color='#FF00FF'>CLodop云打印服务需升级!点击这里<a href='CLodop_Setup_for_Win32NT.exe' target='_self'>执行升级</a>,升级后请刷新页面。</font>";
  var LODOP;
  try {
    var isIE = navigator.userAgent.indexOf('MSIE') >= 0 || navigator.userAgent.indexOf('Trident') >= 0;
    if (needCLodop()) {
      try {
        LODOP = getCLodop();
      } catch (err) {};
      if (!LODOP && document.readyState !== "complete") {
        alert("C-Lodop没准备好，请稍后再试！");return;
      };
      if (!LODOP) {} else {

        if (CLODOP.CVERSION < "3.0.0.2") {
          if (isIE) document.write(strCLodopUpdate);else document.documentElement.innerHTML = strCLodopUpdate + document.documentElement.innerHTML;
        };
        if (oEMBED && oEMBED.parentNode) oEMBED.parentNode.removeChild(oEMBED);
        if (oOBJECT && oOBJECT.parentNode) oOBJECT.parentNode.removeChild(oOBJECT);
      };
    } else {
      var is64IE = isIE && navigator.userAgent.indexOf('x64') >= 0;

      if (oOBJECT != undefined || oEMBED != undefined) {
        if (isIE) LODOP = oOBJECT;else LODOP = oEMBED;
      } else if (CreatedOKLodop7766 == null) {
        LODOP = document.createElement("object");
        LODOP.setAttribute("width", 0);
        LODOP.setAttribute("height", 0);
        LODOP.setAttribute("style", "position:absolute;left:0px;top:-100px;width:0px;height:0px;");
        if (isIE) LODOP.setAttribute("classid", "clsid:2105C259-1E0C-4534-8141-A753534CB4CA");else LODOP.setAttribute("type", "application/x-print-lodop");
        document.documentElement.appendChild(LODOP);
        CreatedOKLodop7766 = LODOP;
      } else LODOP = CreatedOKLodop7766;

      if (LODOP == null || typeof LODOP.VERSION == "undefined") {
        if (navigator.userAgent.indexOf('Chrome') >= 0) document.documentElement.innerHTML = strHtmChrome + document.documentElement.innerHTML;
        if (navigator.userAgent.indexOf('Firefox') >= 0) document.documentElement.innerHTML = strHtmFireFox + document.documentElement.innerHTML;
        if (is64IE) document.write(strHtm64_Install);else if (isIE) document.write(strHtmInstall);else document.documentElement.innerHTML = strHtmInstall + document.documentElement.innerHTML;
        return LODOP;
      };
    };
    if (LODOP.VERSION < "6.0") {
      if (!needCLodop()) {
        if (is64IE) document.write(strHtm64_Update);else if (isIE) document.write(strHtmUpdate);else document.documentElement.innerHTML = strHtmUpdate + document.documentElement.innerHTML;
      };
      return LODOP;
    };

    return LODOP;
  } catch (err) {
    alert("getLodop出错:" + err);
  };
};

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dateToString = dateToString;
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

function dateToString(date) {
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString();
    var day = date.getDate().toString();
    if (month.length == 1) {
        month = "0" + month;
    }
    if (day.length == 1) {
        day = "0" + day;
    }
    var dateTime = year + "-" + month + "-" + day;
    return dateTime;
};

exports.default = {
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    }

};

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.consignmentPrint = consignmentPrint;
exports.consignmentPrint2 = consignmentPrint2;

var _jsbarcode = __webpack_require__(552);

var _jsbarcode2 = _interopRequireDefault(_jsbarcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function consignmentPrint(order_id, receiver, destination, freight_type, print_number) {
    var TYD_print_html = '\n        <!DOCTYPE html>\n<html>\n<head>\n<style>\ntable {\n  border-collapse: collapse;\n  width: 100%; /* \u8BBE\u7F6E\u8868\u683C\u5BBD\u5EA6 */\n  /*width: 368px !* \u8BBE\u7F6E\u8868\u683C\u5BBD\u5EA6 *!*/\n  height: 240px /* \u8BBE\u7F6E\u8868\u683C\u9AD8\u5EA6 */\n}\n\ntd {\n  /*border: 1px solid black; !* \u6DFB\u52A0\u8FB9\u6846\u7EBF\uFF0C\u53EF\u4EE5\u6839\u636E\u9700\u8981\u8C03\u6574\u7EBF\u7684\u6837\u5F0F\u548C\u989C\u8272 *!*/\n  border: 0px solid Gray; /* \u6DFB\u52A0\u8FB9\u6846\u7EBF\uFF0C\u53EF\u4EE5\u6839\u636E\u9700\u8981\u8C03\u6574\u7EBF\u7684\u6837\u5F0F\u548C\u989C\u8272 */\n  padding: 1px; /* \u8BBE\u7F6E\u5355\u5143\u683C\u5185\u8FB9\u8DDD */\n  text-align: center; /* \u6587\u672C\u5C45\u4E2D\u5BF9\u9F50 */\n}\n\n        body {\n            font-family: "Microsoft YaHei",\u5FAE\u8F6F\u96C5\u9ED1,"MicrosoftJhengHei";\n              font-weight: bold; /* \u8BBE\u7F6E\u7C97\u4F53 */\n            /*font-size: 200%;*/\n            font-size: 32px;\n\n        }\n\n            caption {\n        font-weight: bold;\n        font-size: 120%;\n\n    }\n\n\n</style>\n\n</head>\n<body>\n||all_table||\n\n<!--<ta<!--<caption>YT</caption>-->\n<!--  <tr>-->\n<!--    <td>\u8D27&emsp;\u53F7&emsp;:&emsp;||order_id||</td>-->\n<!--  </tr>-->\n<!--  <tr>-->\n<!--    <td>\u5730&emsp;\u5740&emsp;:&emsp;||destination||</td>-->\n<!--  </tr>-->\n<!--  <tr>-->\n<!--    <td>\u6536&emsp;\u8D27&emsp;:&emsp;||receiver||</td>-->\n<!--  </tr>-->\n<!--  <tr>-->\n<!--    <td>\u65B9&emsp;\u5F0F&emsp;:&emsp;||freight_type||</td>-->\n<!--  </tr>-->\n<!--</table>-->\n</body>\n</html>\n\n';

    var table2 = '\n    <table>\n<caption>YT</caption>\n  <tr>\n    <td>\u8D27&emsp;\u53F7:||order_id||</td>\n  </tr>\n  <tr>\n    <td>\u5730&emsp;\u5740:||destination||</td>\n  </tr>\n  <tr>\n    <td>\u6536&emsp;\u8D27:||receiver||</td>\n  </tr>\n  <tr>\n    <td>\u65B9&emsp;\u5F0F:||freight_type||</td>\n  </tr>\n</table>    \n    ';

    var table = '\n    <table>\n<caption>YT</caption>\n  <tr>\n    <td width=\'20%\' height="100px">NO:</td>\n    <td style="font-size:40px">||order_id||\n    </td>\n  </tr>\n  \n  <tr>\n    <td width="20%"  style="font-size:20px" >\u0110\u1ECBa ch\u1EC9:</td>\n    <td style="font-size:30px">||destination||</td>\n  </tr>  \n  <tr>\n    <td width="20%"   style="font-size:20px" >Ng\u01B0\u1EDDi nh\u1EADn:</td>\n    <td style="font-size:30px">||receiver||</td>\n  </tr>\n  \n</table>    \n    ';

    var table3 = '\n    <table>\n<caption>YT</caption>\n  <tr>\n    <td width="100px">\u8D27\u53F7:<br>\n    \u5730\u5740:<br>\n    \u6536\u8D27:<br>\n    \u65B9\u5F0F:</td>\n    <td>||order_id||<br>\n    ||destination||<br>\n    ||receiver||<br>\n    ||freight_type||\n    </td>\n  </tr>\n</table>    \n    ';

    try {

        if (destination.length == 2) {
            var destination_0 = destination.slice(0, 1);
            var destination_1 = destination.slice(1, 2);
            destination = destination_0 + '&emsp;&emsp;' + destination_1;
        }
    } catch (err) {
        destination = '';
    }
    try {
        if (freight_type.length == 2) {
            var freight_type_0 = freight_type.slice(0, 1);
            var freight_type_1 = freight_type.slice(1, 2);
            freight_type = freight_type_0 + '&emsp;&emsp;' + freight_type_1;
        }
    } catch (err) {
        freight_type = '';
    }

    table = table.replace("||order_id||", order_id);
    table = table.replace("||receiver||", receiver);
    table = table.replace("||destination||", destination);
    table = table.replace("||freight_type||", freight_type);
    var all_table = '';
    var i = 0;
    while (i < print_number) {
        all_table = all_table + table;
        i++;
    }
    TYD_print_html = TYD_print_html.replace("||all_table||", all_table);

    return TYD_print_html;
}

function consignmentPrint2(order_id, receiver, destination, freight_type, print_number) {
    var TYD_print_html = '\n        <!DOCTYPE html>\n<html>\n<head>\n<style>\ntable {\n  border-collapse: collapse;\n  /*width: 100%; !* \u8BBE\u7F6E\u8868\u683C\u5BBD\u5EA6 *!*/\n  width: 368px /* \u8BBE\u7F6E\u8868\u683C\u5BBD\u5EA6 */\n  height: 300px /* \u8BBE\u7F6E\u8868\u683C\u9AD8\u5EA6 */\n}\n\ntd {\n  /*border: 1px solid black; !* \u6DFB\u52A0\u8FB9\u6846\u7EBF\uFF0C\u53EF\u4EE5\u6839\u636E\u9700\u8981\u8C03\u6574\u7EBF\u7684\u6837\u5F0F\u548C\u989C\u8272 *!*/\n  border: 0px solid Gray; /* \u6DFB\u52A0\u8FB9\u6846\u7EBF\uFF0C\u53EF\u4EE5\u6839\u636E\u9700\u8981\u8C03\u6574\u7EBF\u7684\u6837\u5F0F\u548C\u989C\u8272 */\n  padding: 1px; /* \u8BBE\u7F6E\u5355\u5143\u683C\u5185\u8FB9\u8DDD */\n  text-align: center; /* \u6587\u672C\u5C45\u4E2D\u5BF9\u9F50 */\n}\n\n        body {\n            font-family: "Microsoft YaHei",\u5FAE\u8F6F\u96C5\u9ED1,"MicrosoftJhengHei";\n              font-weight: bold; /* \u8BBE\u7F6E\u7C97\u4F53 */\n            /*font-size: 200%;*/\n            font-size: 32px;\n\n        }\n\n            caption {\n        font-weight: bold;\n        font-size: 120%;\n\n    }\n\n\n</style>\n\n</head>\n<body>\n||all_table||\n\n<!--<ta<!--<caption>YT</caption>-->\n<!--  <tr>-->\n<!--    <td>\u8D27&emsp;\u53F7&emsp;:&emsp;||order_id||</td>-->\n<!--  </tr>-->\n<!--  <tr>-->\n<!--    <td>\u5730&emsp;\u5740&emsp;:&emsp;||destination||</td>-->\n<!--  </tr>-->\n<!--  <tr>-->\n<!--    <td>\u6536&emsp;\u8D27&emsp;:&emsp;||receiver||</td>-->\n<!--  </tr>-->\n<!--  <tr>-->\n<!--    <td>\u65B9&emsp;\u5F0F&emsp;:&emsp;||freight_type||</td>-->\n<!--  </tr>-->\n<!--</table>-->\n</body>\n</html>\n\n';

    var table2 = '\n    <table>\n<caption>YT</caption>\n  <tr>\n    <td>\u8D27&emsp;\u53F7:||order_id||</td>\n  </tr>\n  <tr>\n    <td>\u5730&emsp;\u5740:||destination||</td>\n  </tr>\n  <tr>\n    <td>\u6536&emsp;\u8D27:||receiver||</td>\n  </tr>\n  <tr>\n    <td>\u65B9&emsp;\u5F0F:||freight_type||</td>\n  </tr>\n</table>    \n    ';

    var table = '\n    <table>\n<caption>YT</caption>\n  <tr>\n    <td width="60px">\u8D27\u53F7:\n    <td style="font-size:40px">||order_id||\n    </td>\n  </tr>\n  <tr>\n      <td width="100px" height="100px">\n    \u5730\u5740:<br>\n    \u6536\u8D27:\n    <td>\n    ||destination||<br>\n    ||receiver||\n    </td>\n  </tr>\n</table>    \n    ';

    var table3 = '\n    <table>\n<caption>YT</caption>\n  <tr>\n    <td width="100px">\u8D27\u53F7:<br>\n    \u5730\u5740:<br>\n    \u6536\u8D27:<br>\n    \u65B9\u5F0F:</td>\n    <td>||order_id||<br>\n    ||destination||<br>\n    ||receiver||<br>\n    ||freight_type||\n    </td>\n  </tr>\n</table>    \n    ';

    try {

        if (destination.length == 2) {
            var destination_0 = destination.slice(0, 1);
            var destination_1 = destination.slice(1, 2);
            destination = destination_0 + '&emsp;&emsp;' + destination_1;
        }
    } catch (err) {
        destination = '';
    }
    try {
        if (freight_type.length == 2) {
            var freight_type_0 = freight_type.slice(0, 1);
            var freight_type_1 = freight_type.slice(1, 2);
            freight_type = freight_type_0 + '&emsp;&emsp;' + freight_type_1;
        }
    } catch (err) {
        freight_type = '';
    }

    table = table.replace("||order_id||", order_id);
    table = table.replace("||receiver||", receiver);
    table = table.replace("||destination||", destination);
    table = table.replace("||freight_type||", freight_type);
    var all_table = '';
    var i = 0;
    while (i < print_number) {
        all_table = all_table + table;
        i++;
    }
    TYD_print_html = TYD_print_html.replace("||all_table||", all_table);

    return TYD_print_html;
}

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(549)
__webpack_require__(548)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(602),
  /* scopeId */
  "data-v-fb057e02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(593);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(591);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(592);

var _Home2 = _interopRequireDefault(_Home);

var _userManage = __webpack_require__(227);

var _userManage2 = _interopRequireDefault(_userManage);

var _adManage = __webpack_require__(594);

var _adManage2 = _interopRequireDefault(_adManage);

var _logManage = __webpack_require__(595);

var _logManage2 = _interopRequireDefault(_logManage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: 'userManage',
    leaf: true,
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/userManage', component: _userManage2.default, name: '用户管理' }]
}, {
    path: '/',
    component: _Home2.default,
    name: 'adManage',
    leaf: true,
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/adManage', component: _adManage2.default, name: '广告管理' }]
}, {
    path: '/',
    component: _Home2.default,
    name: 'logManage',
    leaf: true,
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/logManage', component: _logManage2.default, name: '操作日志' }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(157);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(283);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(284);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(597),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(66);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _this2 = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (value.length < 8) {
        callback(new Error("密码长度请大于8"));
      } else {
        if (_this2.setpwdForm.confirpass !== "") {
          _this2.$refs.setpwdForm.validateField("confirpass");
        }
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== _this2.setpwdForm.newpass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      sysName: "炬星科技",
      collapsed: false,
      sysUserName: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },

      setpwdFormVisible: false,
      editLoading: false,
      setpwdFormRules: {
        oldpass: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newpass: [{ validator: validatePass, trigger: "blur" }],
        confirpass: [{ validator: validatePass2, trigger: "blur" }]
      },
      setpwdForm: {
        oldpass: "",
        newpass: "",
        confirpass: ""
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      console.log("submit!");
    },
    handleopen: function handleopen() {},
    handleclose: function handleclose() {},

    handleselect: function handleselect(a, b) {},

    logout: function logout() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {}).then(function () {
        sessionStorage.removeItem("token");
        _this.$router.push("/login");
      }).catch(function () {});
    },

    settings: function settings() {
      this.setpwdFormVisible = true;
    },
    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.setpwdForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm("确认修改吗？", "提示", {}).then(function () {
            _this3.editLoading = true;
            var para = (0, _assign2.default)({}, _this3.setpwdForm);
            (0, _api.setpwd)(para).then(function (res) {
              _this3.editLoading = false;
              var code = res.code;
              var msg = res.msg;
              if (code !== 0) {
                _this3.$message({
                  message: msg,
                  type: 'error'
                });
              } else {
                _this3.$message({
                  message: msg,
                  type: 'success'
                });
              }
              _this3.$refs["setpwdForm"].resetFields();
              _this3.setpwdFormVisible = false;
            });
          });
        }
      });
    },

    collapse: function collapse() {
      this.collapsed = !this.collapsed;
    },
    showMenu: function showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName("submenu-hook-" + i)[0].style.display = status ? "block" : "none";
    }
  },
  mounted: function mounted() {
    var token = sessionStorage.getItem("token");
    var user = sessionStorage.getItem("name");
    if (token && user) {
      this.sysUserName = user || "";
    } else {
      sessionStorage.removeItem("token");
      this.$router.push("/login");
    }
  }
};

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(65);

var _premission = __webpack_require__(79);

var _userManage = __webpack_require__(227);

var _userManage2 = _interopRequireDefault(_userManage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: ''
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },
  mounted: function mounted() {
    var token = sessionStorage.getItem('token');
    if (token) {
      sessionStorage.setItem('token', token);
      this.$router.push({ path: '/userManage' });
    }
  },

  methods: {
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this2.logining = true;

          var loginParams = { account: _this2.ruleForm2.account, password: _this2.ruleForm2.checkPass };

          (0, _api.requestLogin)(loginParams).then(function (data) {
            _this2.logining = false;

            console.log(data);
            var code = data.code;
            var msg = data.msg;

            if (code !== 0) {
              _this2.$message({
                message: msg,
                type: 'error'
              });
            } else {
              _this2.$message({
                message: msg,
                type: 'success'
              });
              var token = data.data.token;
              var name = data.data.name;
              console.log(token);

              sessionStorage.setItem('token', token);
              sessionStorage.setItem('name', name);

              _this2.$router.push({ path: '/userManage' });
              location.reload();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(66);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(107);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(65);

var _LodopFuncs = __webpack_require__(106);

var _printModel = __webpack_require__(108);

var _premission = __webpack_require__(79);

var _itemStyle = __webpack_require__(149);

var _itemStyle2 = _interopRequireDefault(_itemStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filters: {
        type: "all",
        key: "1",
        all: "1"
      },
      orderInfo: [],
      page_size: 30,
      statusList: [],
      customs_clearance_typeList: [],
      payment_typeList: [],
      freight_typeList: [],
      total: 0,
      page: 1,
      init_order_id: '',
      order_sn: '',
      barcodeList: '',
      listLoading: false,
      sels: [],

      detailFormVisible: false,
      editLoading: false,
      detailFormRules: {
        name: [{ required: true, message: "请输入运单", trigger: "blur" }]
      },

      detailForm: {
        key: '',
        type: '',
        description: "",
        value: ""
      },
      defaultTime: '00:00:00',
      typeOptions: [{ value: 'all', label: '全部' }, { value: 'img', label: '图片' }, { value: 'HTML', label: 'HTML' }],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      creation_date: '',
      value2: ''
    };
  },

  methods: {
    isBase64Image: function isBase64Image(value) {
      return typeof value === 'string' && value.startsWith('data:image');
    },
    beforeUpload: function beforeUpload(file) {
      var _this = this;

      if (!file.type.startsWith('image/')) {
        this.$message.error('请上传图片文件');
        return false;
      }
      if (file.size / 1024 / 1024 > 0.25) {
        this.$message.error('图片大小不能超过 250K');
        return false;
      }

      var reader = new FileReader();
      reader.onload = function (e) {
        _this.detailForm.value = e.target.result;
      };
      reader.readAsDataURL(file);
      return false;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.GetUserListInfo();
    },
    handleSizeChange: function handleSizeChange(val) {
      console.log(val);
      this.page = 1;
      this.page_size = val;
      this.GetUserListInfo();
    },
    saveUser: function saveUser() {
      var _this2 = this;

      this.detailFormVisible = false;
      (0, _api.saveUserInfo)(this.detailForm).then(function (res) {
        _this2.listLoading = false;
        var msg = res.msg;

        _this2.$message({
          message: msg,
          type: "success"
        });

        _this2.GetUserListInfo();
      });
    },
    saveFile: function saveFile() {
      var _this3 = this;

      this.detailFormVisible = false;
      (0, _api.saveFileInfo)(this.detailForm).then(function (res) {
        _this3.listLoading = false;
        var msg = res.message;

        _this3.$message({
          message: msg,
          type: "success"
        });

        _this3.GetFileListInfo();
      });
    },
    limitMaxvalue: function limitMaxvalue() {
      if (this.detailForm.number > 999) {
        this.detailForm.number = 1;
        this.$message("件数最多只能输入999");
      }
    },
    typeFormatter: function typeFormatter(row, column, cellValue) {
      switch (cellValue) {
        case "img":
          return '图片';
        case "HTML":
          return 'HTML';
        default:
          return '未知';}
    },
    handleTypeChange: function handleTypeChange(type) {
      var now = new Date();
      now.setHours(0, 0, 0, 0);
      var effectiveTime = '';

      switch (type) {
        case 10:
          effectiveTime = '9999-12-31 00:00:00';
          break;
        case 20:
          now.setMonth(now.getMonth() + 1);
          effectiveTime = this.formatDate(now);
          break;
        case 30:
          now.setDate(now.getDate() + 1);
          effectiveTime = this.formatDate(now);
          break;
        default:
          effectiveTime = '';}

      this.detailForm.effective_time = effectiveTime;
    },
    formatDate: function formatDate(date) {
      var y = date.getFullYear();
      var m = String(date.getMonth() + 1).padStart(2, '0');
      var d = String(date.getDate()).padStart(2, '0');
      return y + "-" + m + "-" + d + " 00:00:00";
    },
    getAllTypeInfo: function getAllTypeInfo() {
      var _this4 = this;

      var para = {};
      this.listLoading = true;

      (0, _api.getAllType)(para).then(function (res) {
        _this4.statusList = res.data.status;
        _this4.customs_clearance_typeList = res.data.customs_clearance_type;
        _this4.payment_typeList = res.data.payment_type;
        _this4.freight_typeList = res.data.freight_type;
      });
    },
    sourceFormat: function sourceFormat(val, brandList) {
      var branchName = val;
      brandList.forEach(function (item) {
        if (item.key == val) {
          branchName = item.value;
          return branchName;
        }
      });
      return branchName;
    },
    GetUserListInfo: function GetUserListInfo() {
      var _this5 = this;

      var creation_date = [];
      if (this.filters.creation_date != null) {
        if (this.filters.creation_date[0] != null && this.filters.creation_date[1] != null) {
          creation_date[0] = (0, _util.dateToString)(this.filters.creation_date[0]);
          creation_date[1] = (0, _util.dateToString)(this.filters.creation_date[1]);
        }
      }
      var para = {
        page: this.page,
        pageSize: this.page_size,
        userName: this.filters.userName,
        account: this.filters.account,
        phone_number: this.filters.phone_number,
        type: this.filters.type
      };
      console.log(para);
      this.listLoading = true;

      (0, _api.GetUserListPage)(para).then(function (res) {

        var code = res.code;
        var msg = res.msg;

        if (code != 0) {
          _this5.$message(msg);
          _this5.$router.push({ path: '/login' });
        }
        _this5.total = res.data.pagintion.rowTotal;
        _this5.page_size = res.data.pagintion.pageSize;
        _this5.userInfo = res.data.result;
        _this5.listLoading = false;
      });
    },
    GetFileListInfo: function GetFileListInfo() {
      var _this6 = this;

      var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var creation_date = [];
      if (this.filters.creation_date != null) {
        if (this.filters.creation_date[0] != null && this.filters.creation_date[1] != null) {
          creation_date[0] = (0, _util.dateToString)(this.filters.creation_date[0]);
          creation_date[1] = (0, _util.dateToString)(this.filters.creation_date[1]);
        }
      }
      if (this.filters.type == 'all') {
        all = "1";
      };

      var para = {
        key: this.filters.key,
        all: all,
        type: this.filters.type
      };
      console.log(para);
      this.listLoading = true;

      (0, _api.GetFileListPage)(para).then(function (res) {

        var code = res.code;
        var msg = res.msg;

        if (code != 0) {
          _this6.$message(msg);
          _this6.$router.push({ path: '/login' });
        }
        _this6.total = 1;
        _this6.page_size = 1;
        _this6.fileInfo = res.data;
        _this6.listLoading = false;
      });
    },

    handleEdit: function handleEdit(index, row) {
      this.detailFormVisible = true;
      this.detailForm = (0, _assign2.default)({}, row);
    },


    openDetailFormVisible: function openDetailFormVisible() {
      var _this7 = this;

      var para = { aa: "bb" };

      (0, _api.getUserSn)(para).then(function (res) {

        var account = res.data.user_sn;

        _this7.resetForm(account);
      });

      this.detailFormVisible = true;
      this.editMark = true;
    },

    openUpload: function openUpload() {
      this.upload = true;
    },

    resetForm: function resetForm(account) {
      this.detailForm = {
        id: 0,
        account: account,
        passwd: "",
        username: "",
        description: ""
      };
    },
    onUpload: function onUpload(file) {
      var _this8 = this;

      var formData = new FormData();

      formData.append('file', file.file);
      (0, _api.postUpload)(formData).then(function (res) {
        formData.length = 0;
        var count = res.data.data.count;

        var msg = "成功上传" + count + "条记录。";
        _this8.$message.success(msg);
        _this8.getOrderInfo();
        setTimeout(function () {
          location.reload();
        }, 3000);
      }).catch(function (e) {
        _this8.$message.error(e.message);
      });
    },


    checkHasPermission: function checkHasPermission(button_name, view_name) {
      return (0, _premission.hasPermission)(button_name, view_name);
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    batchRemove: function batchRemove() {
      var _this9 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();
      this.$confirm("确认删除选中用户吗？", "提示", {
        type: "warning"
      }).then(function () {
        _this9.listLoading = true;
        var para = { ids: ids };
        (0, _api.batchRemoveUser)(para).then(function (res) {
          _this9.listLoading = false;
          var _res$data = res.data,
              msg = _res$data.msg,
              code = _res$data.code;

          if (code !== 200) {
            _this9.$message({
              message: msg,
              type: "warning"
            });
          } else {
            _this9.$message({
              message: msg,
              type: "success"
            });
          }
          _this9.getUsers();
        });
      }).catch(function () {});
    }
  },
  mounted: function mounted() {
    this.GetFileListInfo();
  }
};

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(66);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(107);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(65);

var _LodopFuncs = __webpack_require__(106);

var _printModel = __webpack_require__(108);

var _premission = __webpack_require__(79);

var _itemStyle = __webpack_require__(149);

var _itemStyle2 = _interopRequireDefault(_itemStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filters: {
        type: "",
        dateRange: [],
        action: "",
        operator: "",
        ipaddr: "",
        unique_by_day: "0",
        date: ["", ""]
      },
      checkboxSelected: false,
      shortcuts: [{
        text: '当天',
        onClick: function onClick(picker) {
          var today = new Date();
          var start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
          var end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '前一天',
        onClick: function onClick(picker) {
          var yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          var start = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0);
          var end = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '本周',
        onClick: function onClick(picker) {
          var today = new Date();
          var dayOfWeek = today.getDay();
          var start = new Date(today);
          start.setDate(today.getDate() - dayOfWeek + 1);
          start.setHours(0, 0, 0, 0);

          var end = new Date(start);
          end.setDate(start.getDate() + 6);
          end.setHours(23, 59, 59, 999);

          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '本月',
        onClick: function onClick(picker) {
          var today = new Date();
          var start = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0);
          var end = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '近三个月',
        onClick: function onClick(picker) {
          var today = new Date();
          var start = new Date(today.getFullYear(), today.getMonth() - 2, 1, 0, 0, 0);
          var end = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59);
          picker.$emit('pick', [start, end]);
        }
      }],
      inputKey: 0,
      orderInfo: [],
      page_size: 30,
      statusList: [],
      customs_clearance_typeList: [],
      payment_typeList: [],
      freight_typeList: [],
      total: 0,
      page: 1,
      init_order_id: '',
      order_sn: '',
      barcodeList: '',
      listLoading: false,
      sels: [],

      detailFormVisible: false,
      editLoading: false,
      detailFormRules: {
        name: [{ required: true, message: "请输入运单", trigger: "blur" }]
      },

      detailForm: {
        id: 0,
        phone_number: "",
        type: null,
        account: "",
        username: "",
        passwd: "",
        effective_time: "",
        description: ""
      },
      defaultTime: '00:00:00',
      typeOptions: [{ value: '', label: '全部' }, { value: 10, label: '永久' }, { value: 20, label: '订阅' }, { value: 30, label: '试用' }],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      creation_date: '',
      value2: ''
    };
  },

  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.GetActionListInfo();
    },
    handleSizeChange: function handleSizeChange(val) {
      console.log(val);
      this.page = 1;
      this.page_size = val;
      this.GetActionListInfo();
    },
    saveUser: function saveUser() {
      var _this = this;

      this.detailFormVisible = false;
      console.log('this.detailForm--');

      if (this.detailForm.effective_time instanceof Date) {
        this.detailForm.effective_time = this.formatDate(this.detailForm.effective_time);
      }
      (0, _api.saveUserInfo)(this.detailForm).then(function (res) {
        _this.listLoading = false;
        var msg = res.msg;

        _this.$message({
          message: msg,
          type: "success"
        });

        _this.GetUserListInfo();
      });
    },
    limitMaxvalue: function limitMaxvalue() {
      if (this.detailForm.number > 999) {
        this.detailForm.number = 1;
        this.$message("件数最多只能输入999");
      }
    },
    typeFormatter: function typeFormatter(row, column, cellValue) {
      switch (cellValue) {
        case 10:
          return '永久';
        case 20:
          return '订阅';
        case 30:
          return '试用';
        default:
          return '未知';}
    },
    handleTypeChange: function handleTypeChange(type) {
      var now = new Date();
      now.setHours(0, 0, 0, 0);
      var effectiveTime = '';

      switch (type) {
        case 10:
          effectiveTime = '9999-12-31 00:00:00';
          break;
        case 20:
          now.setMonth(now.getMonth() + 1);
          effectiveTime = this.formatDate(now);
          break;
        case 30:
          now.setDate(now.getDate() + 1);
          effectiveTime = this.formatDate(now);
          break;
        default:
          effectiveTime = '';}

      this.detailForm.effective_time = effectiveTime;
      console.log('effectiveTime----', effectiveTime);
    },
    formatDate: function formatDate(date) {
      var y = date.getFullYear();
      var m = String(date.getMonth() + 1).padStart(2, '0');
      var d = String(date.getDate()).padStart(2, '0');
      return y + "-" + m + "-" + d + " 00:00:00";
    },
    getAllTypeInfo: function getAllTypeInfo() {
      var _this2 = this;

      var para = {};
      this.listLoading = true;

      (0, _api.getAllType)(para).then(function (res) {
        _this2.login = res.data.login;
        _this2.operation_type = res.data.operation_type;
      });
    },
    sourceFormat: function sourceFormat(val, brandList) {
      var branchName = val;
      brandList.forEach(function (item) {
        if (item.key == val) {
          branchName = item.value;
          return branchName;
        }
      });
      return branchName;
    },
    formatterType: function formatterType(row, column, cellValue) {
      return this.operation_type[cellValue] || cellValue;
    },
    formatterAction: function formatterAction(row, column, cellValue) {
      return this.login[cellValue] || cellValue;
    },
    handleUniqueByDayChange: function handleUniqueByDayChange(val) {
      this.filters.unique_by_day = val ? '1' : '0';
    },
    GetActionListInfo: function GetActionListInfo() {
      var _this3 = this;

      var creation_date = [];
      if (this.filters.creation_date != null) {
        if (this.filters.creation_date[0] != null && this.filters.creation_date[1] != null) {
          creation_date[0] = (0, _util.dateToString)(this.filters.creation_date[0]);
          creation_date[1] = (0, _util.dateToString)(this.filters.creation_date[1]);
        }
      }
      var para = {
        page: this.page,
        pageSize: this.page_size,
        type: this.filters.type,
        action: this.filters.action,
        operator: this.filters.operator,
        ipaddr: this.filters.ipaddr,
        date: this.filters.date,
        unique_by_day: this.filters.unique_by_day

      };
      console.log(para);
      this.listLoading = true;

      (0, _api.GetActionListPage)(para).then(function (res) {

        var code = res.code;
        var msg = res.error_detail;

        if (code != 0) {
          _this3.$message(msg);
          _this3.$router.push({ path: '/login' });
        }
        _this3.total = res.data.pagintion.rowTotal;
        _this3.page_size = res.data.pagintion.pageSize;
        _this3.actionInfo = res.data.result;
        _this3.listLoading = false;
      });
    },


    handleEditStatus: function handleEditStatus(index, row) {
      var _this4 = this;

      var update_status = void 0;
      var confirm_msg = void 0;
      if (row.status == 0) {
        update_status = 1;
        confirm_msg = "确认激活【" + row.account + "】帐号吗？";
      } else {
        update_status = 0;
        confirm_msg = "确认禁用【" + row.account + "】帐号吗？\n禁用后用户无法再登录";
      }

      this.$confirm(confirm_msg, "提示", {
        type: "warning"
      }).then(function () {
        _this4.listLoading = true;

        var para = {
          account: row.account,
          update_status: update_status
        };
        (0, _api.saveUserInfo)(para).then(function (res) {
          _this4.listLoading = false;
          var code = res.code;
          var msg = res.msg;

          if (code != 0) {
            _this4.$message({
              message: msg,
              type: "warning"
            });
          } else {
            _this4.$message({
              message: msg,
              type: "success"
            });
          }
          _this4.GetUserListInfo();
        });
      }).catch(function () {});
    },

    handleEditReset: function handleEditReset(index, row) {
      var _this5 = this;

      var sn = void 0;
      var confirm_msg = void 0;

      confirm_msg = "确认重置【" + row.account + "】 帐号吗？";

      this.$confirm(confirm_msg, "提示", {
        type: "warning"
      }).then(function () {
        _this5.listLoading = true;

        var para = {
          account: row.account,
          update_sn: 'reSet66666666'
        };
        (0, _api.saveUserInfo)(para).then(function (res) {
          _this5.listLoading = false;
          var code = res.code;
          var msg = res.msg;

          if (code != 0) {
            _this5.$message({
              message: msg,
              type: "warning"
            });
          } else {
            _this5.$message({
              message: msg,
              type: "success"
            });
          }
          _this5.GetUserListInfo();
        });
      }).catch(function () {});
    },

    handleDel: function handleDel(index, row) {
      var _this6 = this;

      var message = "确认删除帐号【" + row.account + "】吗?";
      this.$confirm(message, "提示", {
        type: "warning"
      }).then(function () {
        _this6.listLoading = true;
        var para = { account: row.account,
          'enabled_flag': 0 };
        (0, _api.saveUserInfo)(para).then(function (res) {
          _this6.listLoading = false;
          var code = res.code;
          var msg = res.msg;

          if (code != 0) {
            _this6.$message({
              message: msg,
              type: "warning"
            });
          } else {
            _this6.$message({
              message: msg,
              type: "success"
            });
          }
          _this6.GetUserListInfo();
        });
      }).catch(function () {});
    },

    handleEdit: function handleEdit(index, row) {
      this.detailFormVisible = true;
      this.detailForm = (0, _assign2.default)({}, row);
    },


    openDetailFormVisible: function openDetailFormVisible() {
      var _this7 = this;

      var para = { aa: "bb" };

      (0, _api.getUserSn)(para).then(function (res) {

        var account = res.data.user_sn;

        _this7.resetForm(account);
      });

      this.detailFormVisible = true;
      this.editMark = true;
    },

    openUpload: function openUpload() {
      this.upload = true;
    },

    resetForm: function resetForm(account) {
      this.detailForm = {
        id: 0,
        account: account,
        passwd: "",
        username: "",
        description: ""
      };
    },
    getOrderListExcel: function getOrderListExcel() {
      var _this8 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();

      var para = { ids: ids };

      if (ids == "") {
        alert("未选中导出的记录，请选择后再【导出】");
        return 0;
      }

      (0, _api.getOrderListExcelEx)(para).then(function (res) {
        _this8.listLoading = false;
      });
    },
    onUpload: function onUpload(file) {
      var _this9 = this;

      var formData = new FormData();

      formData.append('file', file.file);
      (0, _api.postUpload)(formData).then(function (res) {
        formData.length = 0;
        var count = res.data.data.count;

        var msg = "成功上传" + count + "条记录。";
        _this9.$message.success(msg);
        _this9.getOrderInfo();
        setTimeout(function () {
          location.reload();
        }, 3000);
      }).catch(function (e) {
        _this9.$message.error(e.message);
      });
    },


    checkHasPermission: function checkHasPermission(button_name, view_name) {
      return (0, _premission.hasPermission)(button_name, view_name);
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    batchRemove: function batchRemove() {
      var _this10 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();
      this.$confirm("确认删除选中用户吗？", "提示", {
        type: "warning"
      }).then(function () {
        _this10.listLoading = true;
        var para = { ids: ids };
        (0, _api.batchRemoveUser)(para).then(function (res) {
          _this10.listLoading = false;
          var _res$data = res.data,
              msg = _res$data.msg,
              code = _res$data.code;

          if (code !== 200) {
            _this10.$message({
              message: msg,
              type: "warning"
            });
          } else {
            _this10.$message({
              message: msg,
              type: "success"
            });
          }
          _this10.getUsers();
        });
      }).catch(function () {});
    }
  },
  mounted: function mounted() {
    this.GetActionListInfo();
    this.getAllTypeInfo();
  },

  computed: {
    uniqueByDayChecked: {
      get: function get() {
        return this.filters.unique_by_day === '1';
      },
      set: function set(val) {
        this.filters.unique_by_day = val ? '1' : '0';
      }
    }
  }
};

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(66);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(107);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(65);

var _LodopFuncs = __webpack_require__(106);

var _printModel = __webpack_require__(108);

var _premission = __webpack_require__(79);

var _itemStyle = __webpack_require__(149);

var _itemStyle2 = _interopRequireDefault(_itemStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filters: {
        userName: "",
        account: "",
        phone_number: "",
        type: ""
      },
      orderInfo: [],
      page_size: 30,
      statusList: [],
      customs_clearance_typeList: [],
      payment_typeList: [],
      freight_typeList: [],
      total: 0,
      page: 1,
      init_order_id: '',
      order_sn: '',
      barcodeList: '',
      userInfo: null,
      listLoading: false,
      sels: [],

      detailFormVisible: false,
      editLoading: false,
      detailFormRules: {
        name: [{ required: true, message: "请输入运单", trigger: "blur" }]
      },

      detailForm: {
        id: 0,
        phone_number: "",
        software_type: 1,
        type: null,
        account: "",
        username: "",
        passwd: "",
        effective_time: "",
        description: "",
        buying_channels: "",
        group_name: ""
      },
      defaultTime: '00:00:00',
      typeOptions: [{ value: '', label: '全部' }, { value: 10, label: '永久' }, { value: 20, label: '订阅' }, { value: 30, label: '试用' }],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      creation_date: '',
      value2: ''
    };
  },

  methods: {
    handleSearch: function handleSearch() {
      this.page = 1;
      this.GetUserListInfo();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;

      this.GetUserListInfo();
    },
    handleSizeChange: function handleSizeChange(val) {
      console.log(val);
      this.page = 1;
      this.page_size = val;
      this.GetUserListInfo();
    },
    saveUser: function saveUser() {
      var _this = this;

      this.detailFormVisible = false;
      console.log('this.detailForm--');

      if (this.detailForm.effective_time instanceof Date) {
        this.detailForm.effective_time = this.formatDate(this.detailForm.effective_time);
      }
      (0, _api.saveUserInfo)(this.detailForm).then(function (res) {
        _this.listLoading = false;
        var msg = res.msg;

        _this.$message({
          message: msg,
          type: "success"
        });

        _this.GetUserListInfo();
      });
    },
    limitMaxvalue: function limitMaxvalue() {
      if (this.detailForm.number > 999) {
        this.detailForm.number = 1;
        this.$message("件数最多只能输入999");
      }
    },
    typeFormatter: function typeFormatter(row, column, cellValue) {
      switch (cellValue) {
        case 10:
          return '永久';
        case 20:
          return '订阅';
        case 30:
          return '试用';
        default:
          return '未知';}
    },
    softwareTypeFormatter: function softwareTypeFormatter(row, column, cellValue) {
      if (cellValue === 1 || cellValue === '1') return '人工贴标机';
      if (cellValue === 2 || cellValue === '2') return '自动贴标机';
      return '人工贴标机';
    },
    handleTypeChange: function handleTypeChange(type) {
      var now = new Date();
      now.setHours(0, 0, 0, 0);
      var effectiveTime = '';

      switch (type) {
        case 10:
          effectiveTime = '9999-12-31 00:00:00';
          break;
        case 20:
          now.setMonth(now.getMonth() + 1);
          effectiveTime = this.formatDate(now);
          break;
        case 30:
          now.setDate(now.getDate() + 1);
          effectiveTime = this.formatDate(now);
          break;
        default:
          effectiveTime = '';}

      this.$set(this.detailForm, 'effective_time', effectiveTime);
      console.log('effectiveTime----', effectiveTime);
    },
    formatDate: function formatDate(date) {
      var y = date.getFullYear();
      var m = String(date.getMonth() + 1).padStart(2, '0');
      var d = String(date.getDate()).padStart(2, '0');
      return y + "-" + m + "-" + d + " 00:00:00";
    },
    formatterBuying_channels: function formatterBuying_channels(row, column, cellValue) {
      return this.buying_channels[cellValue] || cellValue;
    },
    getAllTypeInfo: function getAllTypeInfo() {
      var _this2 = this;

      this.listLoading = true;
      var para = {};

      (0, _api.getAllType)(para).then(function (res) {
        _this2.buying_channels = res.data.buying_channels;
        _this2.user_type = res.data.user_type;
      });
    },
    sourceFormat: function sourceFormat(val, brandList) {
      var branchName = val;
      brandList.forEach(function (item) {
        if (item.key == val) {
          branchName = item.value;
          return branchName;
        }
      });
      return branchName;
    },
    GetUserListInfo: function GetUserListInfo() {
      var _this3 = this;

      var creation_date = [];
      if (this.filters.creation_date != null) {
        if (this.filters.creation_date[0] != null && this.filters.creation_date[1] != null) {
          creation_date[0] = (0, _util.dateToString)(this.filters.creation_date[0]);
          creation_date[1] = (0, _util.dateToString)(this.filters.creation_date[1]);
        }
      }
      var para = {
        page: this.page,
        pageSize: this.page_size,
        userName: this.filters.userName,
        account: this.filters.account,
        phone_number: this.filters.phone_number,
        type: this.filters.type
      };
      console.log(para);
      this.listLoading = true;

      (0, _api.GetUserListPage)(para).then(function (res) {

        var code = res.code;
        var msg = res.msg;

        if (code != 0) {
          _this3.$message(msg);
          _this3.$router.push({ path: '/login' });
        }
        _this3.total = res.data.pagintion.rowTotal;
        _this3.page_size = res.data.pagintion.pageSize;
        _this3.userInfo = res.data.result;
        _this3.listLoading = false;
        Vue.nextTick(function () {
          console.log('Table data loaded:', _this3.userInfo);
        });
      });
    },

    handleEditStatus: function handleEditStatus(index, row) {
      var _this4 = this;

      var update_status = void 0;
      var confirm_msg = void 0;
      if (row.status == 0) {
        update_status = 1;
        confirm_msg = "确认激活【" + row.account + "】帐号吗？";
      } else {
        update_status = 0;
        confirm_msg = "确认禁用【" + row.account + "】帐号吗？\n禁用后用户无法再登录";
      }

      this.$confirm(confirm_msg, "提示", {
        type: "warning"
      }).then(function () {
        _this4.listLoading = true;

        var para = {
          account: row.account,
          update_status: update_status
        };
        (0, _api.saveUserInfo)(para).then(function (res) {
          _this4.listLoading = false;
          var code = res.code;
          var msg = res.msg;

          if (code != 0) {
            _this4.$message({
              message: msg,
              type: "warning"
            });
          } else {
            _this4.$message({
              message: msg,
              type: "success"
            });
          }
          _this4.GetUserListInfo();
        });
      }).catch(function () {});
    },

    handleEditReset: function handleEditReset(index, row) {
      var _this5 = this;

      var sn = void 0;
      var confirm_msg = void 0;

      confirm_msg = "确认重置【" + row.account + "】 帐号吗？";

      this.$confirm(confirm_msg, "提示", {
        type: "warning"
      }).then(function () {
        _this5.listLoading = true;

        var para = {
          account: row.account,
          update_sn: 'reSet66666666'
        };
        (0, _api.saveUserInfo)(para).then(function (res) {
          _this5.listLoading = false;
          var code = res.code;
          var msg = res.msg;

          if (code != 0) {
            _this5.$message({
              message: msg,
              type: "warning"
            });
          } else {
            _this5.$message({
              message: msg,
              type: "success"
            });
          }
          _this5.GetUserListInfo();
        });
      }).catch(function () {});
    },

    handleUnlock: function handleUnlock(row) {
      var _this6 = this;

      var confirm_msg = "确认解除【" + row.account + "】的登录锁定吗？";

      this.$confirm(confirm_msg, "提示", {
        type: "warning"
      }).then(function () {
        _this6.listLoading = true;
        return (0, _api.unlockUser)({ account: row.account });
      }).then(function (res) {
        _this6.listLoading = false;
        _this6.$message({
          message: res.msg,
          type: res.code === 0 ? "success" : "warning"
        });
      }).catch(function (error) {
        _this6.listLoading = false;
        if (error && error.message) {
          _this6.$message.error(error.message);
        }
      });
    },

    handleDel: function handleDel(index, row) {
      var _this7 = this;

      var message = "确认删除帐号【" + row.account + "】吗?";
      this.$confirm(message, "提示", {
        type: "warning"
      }).then(function () {
        _this7.listLoading = true;
        var para = { account: row.account,
          'enabled_flag': 0 };
        (0, _api.saveUserInfo)(para).then(function (res) {
          _this7.listLoading = false;
          var code = res.code;
          var msg = res.msg;

          if (code != 0) {
            _this7.$message({
              message: msg,
              type: "warning"
            });
          } else {
            _this7.$message({
              message: msg,
              type: "success"
            });
          }
          _this7.GetUserListInfo();
        });
      }).catch(function () {});
    },

    handleEdit: function handleEdit(index, row) {
      this.detailFormVisible = true;
      this.detailForm = (0, _assign2.default)({}, row);
    },


    openDetailFormVisible: function openDetailFormVisible() {
      var _this8 = this;

      var para = { aa: "bb" };

      (0, _api.getUserSn)(para).then(function (res) {

        var account = res.data.user_sn;

        _this8.resetForm(account);
      });

      this.detailFormVisible = true;
      this.editMark = true;
    },

    openUpload: function openUpload() {
      this.upload = true;
    },

    resetForm: function resetForm(account) {
      this.detailForm = {
        id: 0,
        account: account,
        passwd: "",
        username: "",
        description: "",
        software_type: 1
      };
    },
    getUserListExcel: function getUserListExcel() {
      var _this9 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();
      ids = 9999;
      var para = {
        ids: 99999,
        type: 'userList',
        data: ''
      };

      if (ids == "") {
        alert("未选中导出的记录，请选择后再【导出】");
        return 0;
      }

      (0, _api.getUserListExcelEx)(para).then(function (res) {
        _this9.listLoading = false;
      });
    },
    onUpload: function onUpload(file) {
      var _this10 = this;

      var formData = new FormData();

      formData.append('file', file.file);
      (0, _api.postUpload)(formData).then(function (res) {
        formData.length = 0;
        var count = res.data.data.count;

        var msg = "成功上传" + count + "条记录。";
        _this10.$message.success(msg);
        _this10.getOrderInfo();
        setTimeout(function () {
          location.reload();
        }, 3000);
      }).catch(function (e) {
        _this10.$message.error(e.message);
      });
    },


    checkHasPermission: function checkHasPermission(button_name, view_name) {
      return (0, _premission.hasPermission)(button_name, view_name);
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    batchRemove: function batchRemove() {
      var _this11 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();
      this.$confirm("确认删除选中用户吗？", "提示", {
        type: "warning"
      }).then(function () {
        _this11.listLoading = true;
        var para = { ids: ids };
        (0, _api.batchRemoveUser)(para).then(function (res) {
          _this11.listLoading = false;
          var _res$data = res.data,
              msg = _res$data.msg,
              code = _res$data.code;

          if (code !== 200) {
            _this11.$message({
              message: msg,
              type: "warning"
            });
          } else {
            _this11.$message({
              message: msg,
              type: "success"
            });
          }
          _this11.getUsers();
        });
      }).catch(function () {});
    }
  },
  mounted: function mounted() {
    this.getAllTypeInfo();
    this.GetUserListInfo();
  }
};

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(230);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(234);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(231);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(233);

var _vueRouter = __webpack_require__(235);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(229);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(157);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(228);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(232);

var _axios = __webpack_require__(156);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

var router = new _vueRouter2.default({
  routes: _routes2.default
});

_axios2.default.interceptors.request.use(function (config) {
  var token = sessionStorage.getItem('token');

  if (token) {
    config.headers['Authorization'] = "Bearer " + token;
  }
  config.headers['Content-Type'] = 'application/json;charset=UTF-8';

  return config;
}, function (error) {
  (0, _elementUi.Message)({
    message: "登录状态信息过期,请重新登录",
    type: "error"
  });
  router.push({
    path: "/login"
  });
});

_axios2.default.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        localStorage.removeItem('token');
        router.push({
          path: "/login"
        });
        (0, _elementUi.Message)({
          message: '请检查登录',
          type: 'error'
        });
    }
  }
});

router.beforeEach(function (to, from, next) {
  if (to.path == '/login') {
    sessionStorage.removeItem('token');
  }
  var token = sessionStorage.getItem('token');
  if (!token && to.path != '/login') {
    next({ path: '/login' });
  } else {
    next();
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF0AAABdCAYAAADHcWrDAAAAAXNSR0IArs4c6QAABB5JREFUeF7tnFtIFVEUhn9NCrpQQkFFkg9BYA9GYXSDDDKEQqgoMLIQIopuVlRP+eBTVyoQwpBCIiEqgowQTcwoC6GHCiUMqocuEEFElKaisTsJ5xzmnGbNmZnV7P55da359/7mY8+ecTQLqBkBjxAJVGdlEXqIvH9HEXrYxAldgTihE7oOAYVUrumErkBAIZKmE7oCAYVImk7oCgQUImk6oSsQUIik6YSuQEAhkqYTugIBhUiaTugKBBQiaTqhKxBQiKTphK5AQCGSphO6AgGFyHSm39oFzJwiG9TQMFByFvgxIOvLyQZaDwDjx8r6vvYBq8/Feuq2APPzZP1BVd94CpxqSXH2dNBPbgBWF8iHVfcAuNAh6ysvAo6WynpMdddbYMeVWN/dvXJJ5InuOu73AlXXPECfOhFoqQKys9wFjVZ9HwCWnZD1tFYB0ybJekz1ugvAm88WQTdT8Wr74ZtAa487iIvygYsV7mrjq+Itt8Z0MxGvthv7jIVujoZKoHCWm8rEmnjLrYKeie0b64BXn9LDnD4ZaN4nB55suXXQvdre0QvsT3Uz+cO5pgwoK5RDT7bcOuhebR8eAVacBr71O0MdlwN0HgXGZMugO1luJXSvtjc8Bs7ec4a6bQlwYJUMePKOJb7bii1jMg4vO5n+QWDJccDpD2zaDwG542XQU1lupemZ7GSO3QaaniXCXT4HqC2XAU9nuflZ5VJg4Wx35yzKB8zyJjm+/AC6P7jruPMcaO5OUSt94eXF9ndfgLW1iQNo3A4UzHA3gdGqdJbLzhR7LjDPB5Ljcidwvk3S4RN0r2v75nqg52NsEHm5QNMe+eCddizys8Q6IgXdDNiL7U9eAzuvxiZ8fD1QOk+Gy0/LIwndq+0rzwB9g8CjI/Jtop+WRxK6V9sbuwBzM9pdrGt5ZKF7sf3nEGDet08QvjP32/LIQvdqu8zxxPfl0t509ZG7kY5OxovtUnBBWB5p04O23e8dS/wFj6zpZhJB2h6U5ZE3PSjbg7TcCuhB2B6k5VZA99v2oC23BrqftgdtuTXQ/bI9DMutgu6H7WFYbhX0TG0Py3LroGdie1iWWwfdTMj8Gs78Ok5yvHgPVFySdGRWG+knUqepV68B1i+QQWl7CRy6LuvJpJrQARB6JgqZ/4BH09MTlH4N4OZ6EPpfKBG6G41iNWqfYLgZIk2n6Y4EuHvh7sXNAvKXmzN3L9y9OBHg8sLlhctLKgL/9JbxYAmwdbHs4pnv18137GEd5zYBxXNlabXtQP1DWY9jdRAPRz4My+5TELrC9SV0QlcgoBBJ0wldgYBCJE0ndAUCCpE0ndAVCChE0nRCVyCgEEnTCV2BgEIkTSd0BQIKkTSd0BUIKETSdEJXIKAQSdMJXYGAQiRN14KukPufR/4CD49dfFiuW1UAAAAASUVORK5CYII="

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(54)(
  /* script */
  null,
  /* template */
  __webpack_require__(598),
  /* scopeId */
  "data-v-37e2a448",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(543)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(599),
  /* scopeId */
  "data-v-4adc8e9f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(540)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(596),
  /* scopeId */
  "data-v-2e9a2bd9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(545)
__webpack_require__(544)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(600),
  /* scopeId */
  "data-v-9d7ae882",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)
__webpack_require__(546)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(601),
  /* scopeId */
  "data-v-a26582da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 596:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "remember",
    attrs: {
      "checked": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.collapsed ? '' : _vm.sysName) + "\n\t\t\t")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(590)
    }
  }), _vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.settings.apply(null, arguments)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [(!_vm.collapsed) ? _c('el-menu', {
    staticClass: "el-menu-vertical-demo el-menu-expand",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name))]) : _vm._e()] : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.collapsed) ? _c('ul', {
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.setpwdFormVisible),
      callback: function($$v) {
        _vm.setpwdFormVisible = $$v
      },
      expression: "setpwdFormVisible"
    }
  }, [_c('el-form', {
    ref: "setpwdForm",
    attrs: {
      "model": _vm.setpwdForm,
      "label-width": "80px",
      "rules": _vm.setpwdFormRules
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "原密码",
      "prop": "oldpass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.setpwdForm.oldpass),
      callback: function($$v) {
        _vm.$set(_vm.setpwdForm, "oldpass", $$v)
      },
      expression: "setpwdForm.oldpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newpass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.setpwdForm.newpass),
      callback: function($$v) {
        _vm.$set(_vm.setpwdForm, "newpass", $$v)
      },
      expression: "setpwdForm.newpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "confirpass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.setpwdForm.confirpass),
      callback: function($$v) {
        _vm.$set(_vm.setpwdForm, "confirpass", $$v)
      },
      expression: "setpwdForm.confirpass"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.setpwdFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 100
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选文件类型"
    },
    model: {
      value: (_vm.filters.type),
      callback: function($$v) {
        _vm.$set(_vm.filters, "type", $$v)
      },
      expression: "filters.type"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.GetFileListInfo(0)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fileInfo,
      "highlight-current-row": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "key",
      "label": "key",
      "width": "100",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型",
      "width": "70",
      "align": "center",
      "formatter": _vm.typeFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_date",
      "label": "更新时间",
      "width": "120",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "说明",
      "width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "240",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": [20, 30, 50, 100, 200, 500, 1000],
      "page-size": _vm.page_size,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "广告详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('el-form', {
    ref: "detailForm",
    attrs: {
      "model": _vm.detailForm,
      "label-width": "80px",
      "rules": _vm.detailFormRules,
      "width": "200px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "key"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.detailForm.key),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "key", $$v)
      },
      expression: "detailForm.key"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "文件类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择文件类型",
      "disabled": true
    },
    on: {
      "change": _vm.handleTypeChange
    },
    model: {
      value: (_vm.detailForm.type),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "type", $$v)
      },
      expression: "detailForm.type"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "文件显示"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.isBase64Image(_vm.detailForm.value)) ? _c('img', {
    staticStyle: {
      "max-width": "200px",
      "max-height": "200px",
      "margin-right": "10px"
    },
    attrs: {
      "src": _vm.detailForm.value,
      "alt": "文件预览"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.detailForm.type === 'img') ? _c('el-upload', {
    attrs: {
      "action": "#",
      "before-upload": _vm.beforeUpload,
      "show-file-list": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("上传图片")])], 1) : _vm._e(), _vm._v(" "), (_vm.detailForm.type !== 'img') ? _c('el-input', {
    staticClass: "custom-textarea",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.detailForm.value),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "value", $$v)
      },
      expression: "detailForm.value"
    }
  }) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.description),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "description", $$v)
      },
      expression: "detailForm.description"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveFile
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 100
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入用户",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.operator),
      callback: function($$v) {
        _vm.$set(_vm.filters, "operator", $$v)
      },
      expression: "filters.operator"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入IP地址"
    },
    model: {
      value: (_vm.filters.ipaddr),
      callback: function($$v) {
        _vm.$set(_vm.filters, "ipaddr", $$v)
      },
      expression: "filters.ipaddr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选操作类型"
    },
    model: {
      value: (_vm.filters.type),
      callback: function($$v) {
        _vm.$set(_vm.filters, "type", $$v)
      },
      expression: "filters.type"
    }
  }, [_c('el-option', {
    key: '',
    attrs: {
      "label": '全部',
      "value": ''
    }
  }), _vm._v(" "), _vm._l((this.operation_type), function(label, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": label,
        "value": value
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "选择开始时间"
    },
    model: {
      value: (_vm.filters.date[0]),
      callback: function($$v) {
        _vm.$set(_vm.filters.date, 0, $$v)
      },
      expression: "filters.date[0]"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "选择结束时间"
    },
    model: {
      value: (_vm.filters.date[1]),
      callback: function($$v) {
        _vm.$set(_vm.filters.date, 1, $$v)
      },
      expression: "filters.date[1]"
    }
  }), _vm._v(" "), _c('span', [_vm._v("按天去重")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.uniqueByDayChecked),
      callback: function($$v) {
        _vm.uniqueByDayChecked = $$v
      },
      expression: "uniqueByDayChecked"
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.GetActionListInfo
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.actionInfo,
      "highlight-current-row": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "操作类型",
      "width": "150",
      "align": "center",
      "sortable": "",
      "formatter": _vm.formatterType
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "操作结果",
      "width": "150",
      "align": "center",
      "sortable": "",
      "formatter": _vm.formatterAction
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator",
      "label": "用户名",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ipaddr",
      "label": "IP",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "时间",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": [20, 30, 50, 100, 200, 500, 1000],
      "page-size": _vm.page_size,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "用户详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('el-form', {
    ref: "detailForm",
    attrs: {
      "model": _vm.detailForm,
      "label-width": "80px",
      "rules": _vm.detailFormRules,
      "width": "200px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "帐号",
      "prop": "order_id"
    }
  }, [_c('el-input', {
    staticClass: "readonly-input",
    attrs: {
      "auto-complete": "off",
      "readonly": ""
    },
    model: {
      value: (_vm.detailForm.account),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "account", $$v)
      },
      expression: "detailForm.account"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "phone_number", $$v)
      },
      expression: "detailForm.phone_number"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.username),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "username", $$v)
      },
      expression: "detailForm.username"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择用户类型"
    },
    on: {
      "change": _vm.handleTypeChange
    },
    model: {
      value: (_vm.detailForm.type),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "type", $$v)
      },
      expression: "detailForm.type"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.passwd),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "passwd", $$v)
      },
      expression: "detailForm.passwd"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "请选择有效期",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": _vm.defaultTime
    },
    model: {
      value: (_vm.detailForm.effective_time),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "effective_time", $$v)
      },
      expression: "detailForm.effective_time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.detailForm.description),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "description", $$v)
      },
      expression: "detailForm.description"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveUser
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 100
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入手机"
    },
    model: {
      value: (_vm.filters.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.filters, "phone_number", $$v)
      },
      expression: "filters.phone_number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入帐号"
    },
    model: {
      value: (_vm.filters.account),
      callback: function($$v) {
        _vm.$set(_vm.filters, "account", $$v)
      },
      expression: "filters.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入用户名"
    },
    model: {
      value: (_vm.filters.userName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "userName", $$v)
      },
      expression: "filters.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择用户类型"
    },
    model: {
      value: (_vm.filters.type),
      callback: function($$v) {
        _vm.$set(_vm.filters, "type", $$v)
      },
      expression: "filters.type"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openDetailFormVisible
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUserListExcel
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), (_vm.userInfo) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.userInfo,
      "highlight-current-row": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone_number",
      "label": "手机号",
      "width": "120",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "帐号",
      "width": "60",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "用户名",
      "width": "100",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "passwd",
      "label": "密码",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "software_type",
      "label": "软件类型",
      "width": "100",
      "align": "center",
      "formatter": _vm.softwareTypeFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "用户类型",
      "width": "70",
      "align": "center",
      "formatter": _vm.typeFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buying_channels",
      "label": "渠道",
      "width": "70",
      "align": "center",
      "formatter": _vm.formatterBuying_channels
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "group_name",
      "label": "微信群名",
      "width": "70",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "effective_time",
      "label": "有效时间",
      "width": "100",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.effective_time.substring(0, 10)))])]
      }
    }], null, false, 1360271714)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.status === 0 ? 'danger' : 'success',
            "size": "small"
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.status === 0 ? '禁用' : '激活') + "\n          ")])]
      }
    }], null, false, 423973550)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_date",
      "label": "创建时间",
      "width": "100",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.create_date.substring(0, 10)))])]
      }
    }], null, false, 2080520042)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_login_date",
      "label": "登录时间",
      "width": "100",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.last_login_date && typeof scope.row.last_login_date === 'string' ? scope.row.last_login_date.substring(0, 10) : ''))])]
      }
    }], null, false, 3355743460)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "300",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": scope.row.status === 1 ? 'warning' : 'success'
          },
          on: {
            "click": function($event) {
              return _vm.handleEditStatus(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n                         " + _vm._s(scope.row.status === 1 ? '禁用' : '激活') + "\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditReset(scope.$index, scope.row)
            }
          }
        }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleUnlock(scope.row)
            }
          }
        }, [_vm._v("解锁")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 3179185741)
  })], 1) : _c('div', [_vm._v("Loading...")]), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": [20, 30, 50, 100, 200, 500, 1000],
      "page-size": _vm.page_size,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "用户详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('el-form', {
    ref: "detailForm",
    attrs: {
      "model": _vm.detailForm,
      "label-width": "80px",
      "rules": _vm.detailFormRules,
      "width": "200px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "帐号",
      "prop": "order_id"
    }
  }, [_c('el-input', {
    staticClass: "readonly-input",
    attrs: {
      "auto-complete": "off",
      "readonly": ""
    },
    model: {
      value: (_vm.detailForm.account),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "account", $$v)
      },
      expression: "detailForm.account"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "phone_number", $$v)
      },
      expression: "detailForm.phone_number"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.username),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "username", $$v)
      },
      expression: "detailForm.username"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "软件类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择软件类型"
    },
    model: {
      value: (_vm.detailForm.software_type),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "software_type", $$v)
      },
      expression: "detailForm.software_type"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "人工贴标机"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "自动贴标机"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择用户类型"
    },
    on: {
      "change": _vm.handleTypeChange
    },
    model: {
      value: (_vm.detailForm.type),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "type", $$v)
      },
      expression: "detailForm.type"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.passwd),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "passwd", $$v)
      },
      expression: "detailForm.passwd"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "请选择有效期",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": _vm.defaultTime
    },
    model: {
      value: (_vm.detailForm.effective_time),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "effective_time", $$v)
      },
      expression: "detailForm.effective_time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "渠道类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择渠道类型"
    },
    model: {
      value: (_vm.detailForm.buying_channels),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "buying_channels", $$v)
      },
      expression: "detailForm.buying_channels"
    }
  }, _vm._l((this.buying_channels), function(label, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": label,
        "value": value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "微信群名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.group_name),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "group_name", $$v)
      },
      expression: "detailForm.group_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.detailForm.description),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "description", $$v)
      },
      expression: "detailForm.description"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveUser
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getdrawLineChart = exports.getdrawPieChart = exports.batchRemoveUser = exports.removeUser = exports.getUserListPage = exports.customersInfoDelete = exports.removeSendingReceiving = exports.removeSalesman = exports.removeOrder = exports.getCustomersListInfo = exports.getSalesmanListInfo = exports.getAllType = exports.sendSaveQuotationInfo = exports.updateOrderReconciliation = exports.updateOrder = exports.getUserListExcelEx = exports.getOrderRouteList = exports.getCustomersInfoSn = exports.getSendingReceivingSn = exports.getSalesmanSn = exports.getSenderSelectData = exports.getTodayOrderSnCode = exports.getBarcodeList = exports.checkCustomer = exports.sendSaveCustomersInfo = exports.sendSaveSendingReceiving = exports.saveSalesmanInfo = exports.getCustomersInfoPage = exports.SendingReceivingInfoPage = exports.getSalesmanInfoPage = exports.getQuotationInfoPage = exports.getOrderInfoListPage = exports.setpwd = exports.getUserSn = exports.saveFileInfo = exports.unlockUser = exports.saveUserInfo = exports.GetFileListPage = exports.GetUserListPage = exports.GetActionListPage = exports.requestLogin = undefined;

var _stringify = __webpack_require__(286);

var _stringify2 = _interopRequireDefault(_stringify);

exports.postUpload = postUpload;

var _axios = __webpack_require__(156);

var _axios2 = _interopRequireDefault(_axios);

var _fileSaver = __webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = 'https://re.beyondttyy.top/re';var requestLogin = exports.requestLogin = function requestLogin(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/system_login',

        data: (0, _stringify2.default)(params),
        headers: {
            'Content-Type': 'application/json'
        }

    }).then(function (res) {
        return res.data;
    });
};

var GetActionListPage = exports.GetActionListPage = function GetActionListPage(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/api/getAction/',

        data: (0, _stringify2.default)(params)
    }).then(function (res) {
        return res.data;
    });
};

var GetUserListPage = exports.GetUserListPage = function GetUserListPage(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/get_user_list',

        data: (0, _stringify2.default)(params)
    }).then(function (res) {
        return res.data;
    });
};

var GetFileListPage = exports.GetFileListPage = function GetFileListPage(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/auth/getFile',

        data: (0, _stringify2.default)(params)
    }).then(function (res) {
        return res.data;
    });
};

var saveUserInfo = exports.saveUserInfo = function saveUserInfo(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/saveUser',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var unlockUser = exports.unlockUser = function unlockUser(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/unlock_user',
        data: (0, _stringify2.default)(params)
    }).then(function (res) {
        return res.data;
    });
};

var saveFileInfo = exports.saveFileInfo = function saveFileInfo(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/auth/uploadFile',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var getUserSn = exports.getUserSn = function getUserSn(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/get_user_sn',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var setpwd = exports.setpwd = function setpwd(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/setpwd',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var getOrderInfoListPage = exports.getOrderInfoListPage = function getOrderInfoListPage(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/order/listpage',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};
var getQuotationInfoPage = exports.getQuotationInfoPage = function getQuotationInfoPage(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/getQuotationInfo',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var getSalesmanInfoPage = exports.getSalesmanInfoPage = function getSalesmanInfoPage(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/getSalesmanInfo',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var SendingReceivingInfoPage = exports.SendingReceivingInfoPage = function SendingReceivingInfoPage(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/SendingReceivingInfo',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};
var getCustomersInfoPage = exports.getCustomersInfoPage = function getCustomersInfoPage(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/getCustomersInfo',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var saveSalesmanInfo = exports.saveSalesmanInfo = function saveSalesmanInfo(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/saveSalesmanInfo',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};
var sendSaveSendingReceiving = exports.sendSaveSendingReceiving = function sendSaveSendingReceiving(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/saveSendingReceiving',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};
var sendSaveCustomersInfo = exports.sendSaveCustomersInfo = function sendSaveCustomersInfo(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/sendSaveCustomersInfo',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var checkCustomer = exports.checkCustomer = function checkCustomer(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/checkCustomer',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var getBarcodeList = exports.getBarcodeList = function getBarcodeList(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/getBarcode',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var getTodayOrderSnCode = exports.getTodayOrderSnCode = function getTodayOrderSnCode(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/getTodayOrderSn',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var getSenderSelectData = exports.getSenderSelectData = function getSenderSelectData(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/getSenderSelectData',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var getSalesmanSn = exports.getSalesmanSn = function getSalesmanSn(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/getSalesmanSn',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });

    console.log('getTodayOrderSn2');
};
var getSendingReceivingSn = exports.getSendingReceivingSn = function getSendingReceivingSn(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/getSendingReceivingSn',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });

    console.log('getTodayOrderSn2');
};
var getCustomersInfoSn = exports.getCustomersInfoSn = function getCustomersInfoSn(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/getCustomersInfoSn',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });

    console.log('getTodayOrderSn2');
};

var getOrderRouteList = exports.getOrderRouteList = function getOrderRouteList(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/orderRoute',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var getUserListExcelEx = exports.getUserListExcelEx = function getUserListExcelEx(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/api/usersListExcel/',

        data: (0, _stringify2.default)(params),
        headers: {
            'responseType': "arraybuffer"

        },
        responseType: 'blob'

    }).then(function (res) {
        var link = document.createElement('a');

        var blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '用户列表.xls');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }).catch(function (error) {
        undefined.$Notice.error({
            title: '错误',
            desc: '网络连接错误'
        });
        console.log(error);
    });
};

var updateOrder = exports.updateOrder = function updateOrder(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/save_order',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var updateOrderReconciliation = exports.updateOrderReconciliation = function updateOrderReconciliation(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/save_order',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var sendSaveQuotationInfo = exports.sendSaveQuotationInfo = function sendSaveQuotationInfo(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/sendSaveQuotationInfo',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var getAllType = exports.getAllType = function getAllType(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/api/getAllType/',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};
var getSalesmanListInfo = exports.getSalesmanListInfo = function getSalesmanListInfo(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/getSalesmanList',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};
var getCustomersListInfo = exports.getCustomersListInfo = function getCustomersListInfo(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/getCustomersList',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

function postUpload(file) {
    return (0, _axios2.default)({
        url: base + '/upload',
        method: 'post',
        data: file,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

var removeOrder = exports.removeOrder = function removeOrder(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/orderDelete',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var removeSalesman = exports.removeSalesman = function removeSalesman(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/salesmanDelete',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};
var removeSendingReceiving = exports.removeSendingReceiving = function removeSendingReceiving(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/sendingReceivingDelete',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var customersInfoDelete = exports.customersInfoDelete = function customersInfoDelete(params) {
    return (0, _axios2.default)({
        method: 'POST',
        url: base + '/customersInfoDelete',

        data: (0, _stringify2.default)(params)

    }).then(function (res) {
        return res.data;
    });
};

var getUserListPage = exports.getUserListPage = function getUserListPage(params) {
    return _axios2.default.get(base + '/users/listpage', { params: params });
};

var removeUser = exports.removeUser = function removeUser(params) {
    return _axios2.default.get(base + '/user/remove', { params: params });
};

var batchRemoveUser = exports.batchRemoveUser = function batchRemoveUser(params) {
    return _axios2.default.get(base + '/user/bathremove', { params: params });
};

var getdrawPieChart = exports.getdrawPieChart = function getdrawPieChart() {
    return _axios2.default.get(base + '/getdrawPieChart');
};

var getdrawLineChart = exports.getdrawLineChart = function getdrawLineChart() {
    return _axios2.default.get(base + '/getdrawLineChart');
};

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(285);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.hasPermission = hasPermission;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasPermission(button_name, view_name) {
    var check_admin = sessionStorage.getItem('name');
    if (check_admin == 'admin') return true;
    var hasPermission = false;
    var menus = sessionStorage.getItem('menus');
    var menus2 = sessionStorage.getItem('menus2');
    var buttons = sessionStorage.getItem('buttons');
    var buttonId = 0;
    var viewId = '';
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(JSON.parse(menus)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _item = _step.value;

            if (_item.value == view_name && _item.view == 0) {
                viewId = _item.id;
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {

        for (var _iterator2 = (0, _getIterator3.default)(JSON.parse(menus)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _item2 = _step2.value;

            if (_item2.view == viewId && _item2.value == button_name) {
                buttonId = _item2.id;
                break;
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {

        for (var _iterator3 = (0, _getIterator3.default)(buttons.split(",")), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _item3 = _step3.value;

            if (_item3 == buttonId) {
                hasPermission = true;
                return hasPermission;
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    if (button_name == '0') {
        console.log(viewId);
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = (0, _getIterator3.default)(menus2.split(",")), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var item = _step4.value;

                if (item == viewId || item.toString() == viewId) {
                    hasPermission = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
    }

    return hasPermission;
}

/***/ })

},[282]);


// WEBPACK FOOTER //
// static/js/app.f647d4f134711eb6273d.js